import axios from 'axios'
import { apiUrl } from '../utils/apiUrl'

const baseUrl = apiUrl('7cfc20a8bd34098ca6782272a7f324302b35dba14231803e904838dd0752558a')
// const baseUrl = 'https://improve-bot.delightfulbush-65d4f852.westus3.azurecontainerapps.io/7cfc20a8bd34098ca6782272a7f324302b35dba14231803e904838dd0752558a'

// const baseUrl = 'https://3af5-191-114-134-242.ngrok.io/7cfc20a8bd34098ca6782272a7f324302b35dba14231803e904838dd0752558a'

export const register = async ({mail, name, customer, password, number, tokenGoogle, tokenFacebook, isKriator }) => {
  console.log({isKriator})
  const { data } = await axios.post(baseUrl, {
    mail,
    name,
    customer,
    password,
    number,
    tokenGoogle,
    tokenFacebook,
    kriator: isKriator
  })
  return data
}